import React, { Component } from 'react';
import { Button, Col, Form, Input, message, Modal, Row, Select } from 'antd';
import YearPicker from '@comm/YearPicker';
import { queryBudgetGroupAims } from '@api/finance/budget';
import { queryDictIncome } from '@api/core/dict';

const FormItem = Form.Item;
const { Option } = Select;

class IndexModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupList: [],
      targetArr: [],
      sumAim: 0,
    };
  }

  componentDidMount() {
    this.loadDictIncome();
    this.getGroupList();
  }

  // 获得资金类型
  loadDictIncome = () => {
    queryDictIncome().then(res => {
      if (res.statusCode === 200) {
        res.data.map(item => {
          item.flag = false;
          return 1;
        });
        this.setState({
          type: res.data,
        });
      }
    });
  };

  // 获得历史数据
  getBudgetGroupAims = params => {
    queryBudgetGroupAims(params).then(res => {
      if (res.statusCode === 200) {
        if (res.data) {
          res.data.aims &&
            res.data.aims.map(item => {
              item.id = item.uuid;
              return item;
            });
          this.setState(
            {
              sumAim: res.data.sumAim,
              targetArr: res.data.aims || [],
            },
            () => {
              this.changeArrFlag();
            },
          );
        }
      } else {
        message.error(res.message);
      }
    });
  };

  /** 设置预算组列表 */
  formatGroup = arr => {
    arr.map(item => {
      if (item.children) {
        if (item.children.length === 0) {
          delete item.children;
          return item;
        }
        if (item.children.length > 0) {
          this.formatGroup(item.children);
        }
      }
      return item;
    });
    return arr;
  };

  formatOption = arr => {
    const { groupList } = this.state;
    (arr || []).map(item => {
      if (item.children && item.children.length > 0) {
        this.formatOption(item.children);
      }
      groupList.push(item);
      return item;
    });
    this.setState({ groupList });
  };

  getGroupList = () => {
    const { companyAll } = this.props.data;
    const companyList = this.formatGroup(companyAll);
    this.formatOption(companyList);
  };

  changeGroupUuid = e => {
    const year = this.props.form.getFieldValue('year');
    const groupUuid = e;
    this.setState({
      sumAim: 0,
      targetArr: [],
    });
    year &&
      groupUuid &&
      this.getBudgetGroupAims({
        groupUuid,
        year,
      });
    return e;
  };

  changeYear = e => {
    const groupUuid = this.props.form.getFieldValue('groupUuid');
    const year = e;
    this.setState({
      sumAim: 0,
      targetArr: [],
    });
    year &&
      groupUuid &&
      this.getBudgetGroupAims({
        groupUuid,
        year,
      });
    return e;
  };

  // 使选过的资金类型不可以再选
  changeArrFlag = () => {
    const { targetArr, type } = this.state;
    let newType = [];
    targetArr.map(item => {
      newType = newType.concat(item.types);
      return 1;
    });
    type.map(item => {
      item.flag = newType.includes(item.value);
      return 1;
    });
    this.setState({
      type,
    });
  };

  // 新增具体类目
  handleAdd = () => {
    const { targetArr } = this.state;
    targetArr.push({ id: new Date().getTime() });
    this.setState({
      targetArr,
    });
    this.changeArrFlag();
  };

  // 删除具体类目
  handleSub = index => {
    const { targetArr } = this.state;
    targetArr.splice(index, 1);
    this.setState({
      targetArr,
    });
    this.changeArrFlag();
  };

  // 具体类目收入验证
  validateMax = (rule, value, callback) => {
    const sumAim = this.props.form.getFieldValue('sumAim');

    if (value > sumAim) {
      callback('不能大于总收入目标');
    }
    callback();
  };

  // 总收入目标验证
  validateMin = (rule, value, callback) => {
    const { targetArr } = this.state;
    let num = 0;
    targetArr.map(item => {
      num += item.aim;
      return 1;
    });
    if (value < num) {
      callback('不能小于类目收入之和');
    }
    callback();
  };

  // 更新targetArr.item.type
  changeArrType = (id, e) => {
    const { targetArr } = this.state;
    targetArr.map(item => {
      if (item.id === id) {
        item.types = e;
      }
      return 1;
    });

    this.setState({ targetArr });
    return e;
  };

  // 更新targetArr.item.Aim
  changeArrAim = (id, e) => {
    const { targetArr } = this.state;
    const val = +e.target.value;

    targetArr.map(item => {
      if (item.id === id) {
        item.aim = val;
      }
      return 1;
    });
    this.setState({ targetArr });
    return val;
  };

  // 提交
  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { targetArr } = this.state;
    const target = this.props.form.getFieldsValue();

    this.props.form.validateFields(err => {
      if (!err) {
        const { groupUuid } = target;
        const { sumAim } = target;
        const { year } = target;
        this.props.handSubmit({
          groupUuid,
          sumAim,
          year,
          aims: targetArr,
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { targetArr, type } = this.state;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    return (
      <Modal
        title={this.props.title}
        visible
        width={600}
        onOk={this.submit}
        onCancel={this.props.cancel}
      >
        <Form>
          <FormItem label="选择预算组" {...formItemLayout}>
            {getFieldDecorator('groupUuid', {
              rules: [{ required: true, message: '请选择预算组' }],
              getValueFromEvent: this.changeGroupUuid,
            })(
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                placeholder="请选择预算组"
              >
                {this.state.groupList.map(item => {
                  return <Option key={item.uuid}>{item.name}</Option>;
                })}
              </Select>,
            )}
          </FormItem>
          <FormItem label="选择年份" {...formItemLayout}>
            {getFieldDecorator('year', {
              rules: [{ required: true, message: '请选择年份' }],
              getValueFromEvent: this.changeYear,
            })(<YearPicker />)}
          </FormItem>
          <FormItem label="目标收入" {...formItemLayout}>
            {getFieldDecorator('sumAim', {
              rules: [
                { required: true, message: '请填写目标收入' },
                { validator: this.validateMin },
              ],
              initialValue: this.state.sumAim || '',
            })(
              <Input
                addonAfter={<span>元</span>}
                min={0}
                placeholder="请填写本年总的收入目标"
                type="number"
              />,
            )}
          </FormItem>
          {targetArr.map((item, index) => (
            <Row key={item.id}>
              <Col span={2} />
              <Col span={18}>
                <Row>
                  <Col span={10}>
                    <FormItem>
                      {getFieldDecorator(`types${item.id}`, {
                        rules: [{ required: true, message: '请选择资金类型' }],
                        getValueFromEvent: e => this.changeArrType(item.id, e),
                        initialValue: item.types || [],
                      })(
                        <Select
                          mode="multiple"
                          filterOption={(input, option) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                          placeholder="请选择资金类型"
                        >
                          {type.map(item1 => {
                            return (
                              <Option key={item1.value} disabled={item1.flag}>
                                {item1.key}
                              </Option>
                            );
                          })}
                        </Select>,
                      )}
                    </FormItem>
                  </Col>
                  <Col span={1} />
                  <Col span={10}>
                    <FormItem>
                      {getFieldDecorator(`aim${item.id}`, {
                        rules: [
                          { required: true, message: '请填写目标收入' },
                          { validator: this.validateMax },
                        ],
                        getValueFromEvent: e => this.changeArrAim(item.id, e),
                        initialValue: item.aim || '',
                      })(
                        <Input
                          addonAfter={<span>元</span>}
                          type="number"
                          min={1}
                          placeholder="请填写收入目标"
                        />,
                      )}
                    </FormItem>
                  </Col>
                  <Col span={1} />
                  <Col span={2}>
                    <FormItem>
                      <Button onClick={() => this.handleSub(index)}>-</Button>
                    </FormItem>
                  </Col>
                </Row>
              </Col>
            </Row>
          ))}
          <Row>
            <Col span={2} />
            <Col span={18}>
              <Button type="dashed" block onClick={this.handleAdd}>
                +新增具体类目的目标收入
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(IndexModal);



// WEBPACK FOOTER //
// ./src/components/finance/budget/ModalSetTarget.js